const language = {
    'pt': 
        {
            access_app_link:                        'AQUI!',
            access_app_txt:                         'Verifique essa informação acedendo à plataforma',
            back:                                   'Voltar',
            documents:                              'Documentos',
            documents_add:                          'Adicionar documentos',
            documents_email_sent:                   'Documentos adicionados na sua área reservada.',
            download:                               'Descarregar',
            downloads:                              'Downloads',
            downloads_add:                          'Adicionar downloads',
            downloads_email_sent:                   'Downloads adicionados na sua área reservada.',
            field_date:                             'Data',
            field_date_read:                        'Lida',
            field_name:                             'Nome',
            field_client_name:                      'Nome do cliente',
            file_download:                          'Ficheiro',
            folder:                                 'Pasta',
            save:                                   'Salvar',
            section:                                'Secção',
            section_choose:                         'Escolher secção',
            section_name_placeholder:               'Inserir o nome da secção',
            section_new:                            'Adicionar secção',
            send:                                   'Enviar',
            table_all:                              'Todos',
            subject_documents_email:                'Documentos adicionados',
            subject_downloads_email:                'Downloads adicionados',
            table_empty:                            'Sem dados para mostrar',
            table_loading:                          'Loading...',
            table_rows_per_page:                    'registo por página',
            table_separator:                        'de',
        },
    'en':
        {
            access_app_link:                        'AQUI!',
            access_app_txt:                         'Verifique essa informação acedendo à plataforma',
            back:                                   'Voltar',
            documents:                              'Documentos',
            documents_add:                          'Adicionar documentos',
            documents_email_sent:                   'Documentos adicionados na sua área reservada.',
            download:                               'Download',
            downloads:                              'Downloads',
            downloads_add:                          'Adicionar downloads',
            downloads_email_sent:                   'Downloads adicionados na sua área reservada.',
            field_date:                             'Data',
            field_date_read:                        'Lida',
            field_name:                             'Nome',
            field_client_name:                      'Nome do cliente',
            file_download:                          'Ficheiro',
            folder:                                 'Pasta',
            save:                                   'Salvar',
            section:                                'Secção',
            section_choose:                         'Escolher secção',
            section_name_placeholder:               'Inserir o nome da secção',
            section_new:                            'Adicionar secção',
            send:                                   'Enviar',
            table_all:                              'Todos',
            subject_documents_email:                'Documentos adicionados',
            subject_downloads_email:                'Downloads adicionados',
            table_empty:                            'Sem dados para mostrar',
            table_loading:                          'Loading...',
            table_rows_per_page:                    'registo por página',
            table_separator:                        'de',
        },  
    'es':
        {
            access_app_link:                        'AQUI!',
            access_app_txt:                         'Verifique essa informação acedendo à plataforma',
            back:                                   'Voltar',
            documents:                              'Documentos',
            documents_add:                          'Adicionar documentos',
            documents_email_sent:                   'Documentos adicionados na sua área reservada.',
            download:                               'Descarregar',
            downloads:                              'Downloads',
            downloads_add:                          'Adicionar downloads',
            downloads_email_sent:                   'Downloads adicionados na sua área reservada.',
            field_date:                             'Data',
            field_date_read:                        'Lida',
            field_name:                             'Nome',
            field_client_name:                      'Nome do cliente',
            file_download:                          'Ficheiro',
            folder:                                 'Pasta',
            save:                                   'Salvar',
            section:                                'Secção',
            section_choose:                         'Escolher secção',
            section_name_placeholder:               'Inserir o nome da secção',
            section_new:                            'Adicionar secção',
            send:                                   'Enviar',
            table_all:                              'Todos',
            subject_documents_email:                'Documentos adicionados',
            subject_downloads_email:                'Downloads adicionados',
            table_empty:                            'Sem dados para mostrar',
            table_loading:                          'Loading...',
            table_rows_per_page:                    'registo por página',
            table_separator:                        'de',
        },
    'fr': 
        {
            access_app_link:                        'AQUI!',
            access_app_txt:                         'Verifique essa informação acedendo à plataforma',
            back:                                   'Voltar',
            documents:                              'Documentos',
            documents_add:                          'Adicionar documentos',
            documents_email_sent:                   'Documentos adicionados na sua área reservada.',
            download:                               'Descarregar',
            downloads:                              'Downloads',
            downloads_add:                          'Adicionar downloads',
            downloads_email_sent:                   'Downloads adicionados na sua área reservada.',
            field_date:                             'Data',
            field_date_read:                        'Lida',
            field_name:                             'Nome',
            field_client_name:                      'Nome do cliente',
            file_download:                          'Ficheiro',
            folder:                                 'Pasta',
            save:                                   'Salvar',
            section:                                'Secção',
            section_choose:                         'Escolher secção',
            section_name_placeholder:               'Inserir o nome da secção',
            section_new:                            'Adicionar secção',
            send:                                   'Enviar',
            subject_documents_email:                'Documentos adicionados',
            subject_downloads_email:                'Downloads adicionados',
            table_all:                              'Todos',
            table_empty:                            'Sem dados para mostrar',
            table_loading:                          'Loading...',
            table_rows_per_page:                    'registo por página',
            table_separator:                        'de',
        },

}

module.exports = {
    language
};